/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_TeamInputs */

const en_for_whom_tag_team = /** @type {(inputs: For_Whom_Tag_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const pl_for_whom_tag_team = /** @type {(inputs: For_Whom_Tag_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zespół`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {For_Whom_Tag_TeamInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_team = /** @type {((inputs?: For_Whom_Tag_TeamInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_TeamInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_team(inputs)
	return en_for_whom_tag_team(inputs)
});